/**
 * Appstle 配送频率 — 自定义下拉（Figma 1:2529）
 * 隐藏原生 select；选项倒序；下拉列表绝对定位在触发器下方
 */
(function () {
  var INIT_ATTR = 'data-appstle-custom-select';

  function triggerAppstleChange(select) {
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.dispatchEvent(new Event('input', { bubbles: true }));
    if (typeof jQuery !== 'undefined') {
      jQuery(select).trigger('change');
    }
  }

  function getSelectedLabel(select) {
    var opt = select.options[select.selectedIndex];
    return opt ? opt.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function getOptionsArray(select) {
    return Array.prototype.filter.call(select.options, function (opt) {
      return opt.value || opt.textContent.trim();
    });
  }

  function isAppstlePlaceholderEmpty(placeholder) {
    if (!placeholder) return true;
    return !placeholder.textContent.trim() && placeholder.children.length === 0;
  }

  function syncPriceReviewVisibility(scope) {
    var roots = scope
      ? [scope]
      : Array.prototype.slice.call(document.querySelectorAll('.t4s-product__info-container'));

    roots.forEach(function (root) {
      if (!root || !root.querySelector) return;

      var priceReview = root.querySelector('.t4s-product__price-review');
      if (!priceReview) return;

      var placeholder =
        root.querySelector('#appstle-subscription-widget-placeholder') ||
        document.querySelector('#appstle-subscription-widget-placeholder');

      var hasSubscriptionWrapper = !!root.querySelector('.appstle_subscription_wrapper');
      var showPriceReview = isAppstlePlaceholderEmpty(placeholder) && !hasSubscriptionWrapper;

      priceReview.classList.toggle('is-visible', showPriceReview);
    });
  }

  function closeDropdown(root) {
    var list = root._appstleList || root.querySelector('.appstle-custom-select__list');
    var trigger = root.querySelector('.appstle-custom-select__trigger');
    root.setAttribute('data-open', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (list) list.hidden = true;
  }

  function openDropdown(root) {
    var list = root._appstleList || root.querySelector('.appstle-custom-select__list');
    var trigger = root.querySelector('.appstle-custom-select__trigger');
    if (!list || !trigger) return;

    root.setAttribute('data-open', 'true');
    trigger.setAttribute('aria-expanded', 'true');
    list.hidden = false;
  }

  function syncUiFromSelect(select, root) {
    var valueEl = root.querySelector('.appstle-custom-select__value');
    var selectedValue = select.value;
    if (valueEl) valueEl.textContent = getSelectedLabel(select);

    var list = root._appstleList || root.querySelector('.appstle-custom-select__list');
    if (!list) return;

    list.querySelectorAll('.appstle-custom-select__option').forEach(function (btn) {
      var isSelected = btn.getAttribute('data-value') === selectedValue;
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
  }

  function rebuildOptions(select, list, root) {
    if (!root) root = list.closest('.appstle-custom-select');
    list.innerHTML = '';

    var options = getOptionsArray(select);
    options.reverse();

    options.forEach(function (opt) {
      var li = document.createElement('li');
      li.className = 'appstle-custom-select__item';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'appstle-custom-select__option';
      btn.setAttribute('data-value', opt.value);
      btn.textContent = opt.textContent.replace(/\s+/g, ' ').trim();

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (select.value !== opt.value) {
          select.value = opt.value;
          syncUiFromSelect(select, root);
          triggerAppstleChange(select);
        }
        closeDropdown(root);
      });

      li.appendChild(btn);
      list.appendChild(li);
    });
  }

  function buildCustomSelect(select) {
    if (select.getAttribute(INIT_ATTR) === 'true') return;

    var wrapper = select.closest('.appstle_custom_select');
    if (!wrapper) return;

    select.setAttribute(INIT_ATTR, 'true');
    wrapper.classList.add('appstle-custom-select-root');
    select.classList.add('appstle_select--native');
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;

    var root = document.createElement('div');
    root.className = 'appstle-custom-select';
    root.setAttribute('data-open', 'false');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'appstle-custom-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var valueEl = document.createElement('span');
    valueEl.className = 'appstle-custom-select__value';

    var iconEl = document.createElement('span');
    iconEl.className = 'appstle-custom-select__icon';
    iconEl.setAttribute('aria-hidden', 'true');

    trigger.appendChild(valueEl);
    trigger.appendChild(iconEl);

    var list = document.createElement('ul');
    list.className = 'appstle-custom-select__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    root.appendChild(trigger);
    root.appendChild(list);
    wrapper.appendChild(root);

    root._appstleList = list;

    rebuildOptions(select, list, root);
    syncUiFromSelect(select, root);

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (root.getAttribute('data-open') === 'true') {
        closeDropdown(root);
      } else {
        openDropdown(root);
      }
    });

    select.addEventListener('change', function () {
      syncUiFromSelect(select, root);
    });

    root._outsideClick = function (e) {
      if (!wrapper.contains(e.target)) closeDropdown(root);
    };
    document.addEventListener('click', root._outsideClick);

    root._escapeKey = function (e) {
      if (e.key === 'Escape') closeDropdown(root);
    };
    document.addEventListener('keydown', root._escapeKey);

    var optionObserver = new MutationObserver(function () {
      rebuildOptions(select, list, root);
      syncUiFromSelect(select, root);
    });
    optionObserver.observe(select, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['selected']
    });
  }

  function scan() {
    document
      .querySelectorAll('.t4s-product__info-container .appstle_custom_select select.appstle_select')
      .forEach(buildCustomSelect);
    syncPriceReviewVisibility();
  }

  function observeAppstle() {
    var observeRoot =
      document.querySelector('.t4s-product__info-container') ||
      document.querySelector('.appstle_sub_widget') ||
      document.body;

    var timer;
    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        scan();
        syncPriceReviewVisibility(observeRoot.closest && observeRoot.closest('.t4s-product__info-container'));
      }, 80);
    });
    mo.observe(observeRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
      observeAppstle();
    });
  } else {
    scan();
    observeAppstle();
  }
})();
